package one.healthium.data.user.dto

import kotlinx.serialization.Serializable

@Serializable
internal data class CredentialsDto(
    val email: String,
    val password: String
)
